import { registerCdpBindings } from "./bindings";
import { ensureStub, scheduleSelfLoadFallback } from "./rudder-client";

/**
 * Initialise the CDP layer. Call once at app startup, before first render.
 * No-ops entirely in sandbox builds (see rudder-client).
 *
 *  - ensureStub:               guarantees app-side track/identify calls queue
 *                              even if GTM hasn't loaded RudderStack yet.
 *  - scheduleSelfLoadFallback: optionally loads the SDK ourselves if GTM never
 *                              does (only when write key + data plane are set).
 *  - registerCdpBindings:      subscribes funnel events to the booking effects.
 */
export const initCdp = (): void => {
  ensureStub();
  scheduleSelfLoadFallback();
  registerCdpBindings();
};

export {
  CDP_EVENTS,
  trackAppointmentBooked,
  trackExperimentViewed,
  trackLeadCreated,
  trackPromoCodeEntered,
  trackPromoCodeInvalid,
  trackPromoCodeValid,
  trackQuoteCreated,
} from "./events";
export {
  cdpIdentify,
  cdpPage,
  cdpReset,
  cdpTrack,
  isCdpEnabled,
} from "./rudder-client";
